import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { tableListSvg } from './svg/tableList';

export const TableListIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={tableListSvg} {...props} />
);
